import React,{ Component } from "react";
import { connect } from "react-redux";
import ZoneForm from "../ZoneForm/ZoneForm";
import { createZone } from "../../../actions/actionZones";
import { Row, Col, Card, CardHeader, Container} from "reactstrap";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../../components/Breadcrumb/BreadCrumbCompo";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Zone",path:"/zone",isActive: false},
    {name: "CreateZone",path:"/createzone",isActive: true},
];

class CreateZone extends Component{
    render(){
        return (
            <div>    
                <BreadCrumbCompo routes={routes}/>   
                <Row>
                    <Container>
                        <Col sm={{ size: 8, order: 3, offset: 2 }}>
                            <Card className = "user-form-container">
                                <CardHeader>
                                    <i className="fa fa-edit"></i> <strong>Create Deployment Zone</strong>
                                </CardHeader>
                                <ZoneForm
                                    createZone={this.props.createZone}
                                />
                            </Card>
                        </Col>
                    </Container>
                </Row>
            </div>
        );
    }
}

CreateZone.propTypes = {
    createZone: Proptypes.func.isRequired,
};

export default connect(state => ({
    zones: state.zones.zones || []
}), 
dispatch => ({
    createZone: (data) => dispatch(createZone(data)),
}))(CreateZone);


// WEBPACK FOOTER //
// ./src/views/Zones/CreateZone/CreateZone.js